export default "__VITE_ASSET__BIZi35p3__"